<div class="container">
  <div class="text-center">
    <h5 class="display-5 mt-3 mb-4">Change Homepage Content</h5>
  </div>
</div>

<div class="container">
  <div class="main-content mt-5 p-3">
    <h4 class="pb-3">Modify Main Content</h4>

    <label>Content title:</label>
    <div class="input-group input-group-lg mb-3">
      <input type="text" class="form-control" [(ngModel)]="contentTitle">
    </div>

    <label>Content points:</label>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">✓</span>
      </div>
      <input type="text" class="form-control" [(ngModel)]="contentPoint1">
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">✓</span>
      </div>
      <input type="text" class="form-control" [(ngModel)]="contentPoint2">
    </div>
    <div class="input-group mb-4">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">✓</span>
      </div>
      <input type="text" class="form-control" [(ngModel)]="contentPoint3">
    </div>

    <button type="button" class="btn btn-primary update-btn" (click)="onUpdate()">Update</button>
  </div>
</div>

<div class="container">
  <div class="tag-lines mt-5 p-3">
    <h4 class="pb-3">Modify Tag Lines</h4>

    <label>Tag title:</label>
    <div class="input-group input-group-lg mb-3">
      <input type="text" class="form-control" [(ngModel)]="tagHeading">
    </div>

    <label>Tag description:</label>
    <div class="input-group input-grou mb-3">
      <textarea class="form-control form-control-lg" rows="2" [(ngModel)]="tagLine"></textarea>
      <!-- <input type="text" class="form-control"> -->
    </div>
    <button type="button" class="btn btn-primary update-btn" (click)="onUpdate()">Update</button>
  </div>
</div>
